import { flushEvents } from "@api/session";
import { onMount } from "solid-js";

export const SessionMaker = () => {
  onMount(() => {
    window.addEventListener("pagehide", flushEvents);

    return () => {
      window.removeEventListener("pagehide", flushEvents);
    };
  });

  return <></>;
};
